import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export abstract class CookiesService {

  abstract server8Mode$: BehaviorSubject<boolean>;
  abstract isCookieEnabled(name): boolean;
  abstract setCookie(name, value): void;
  abstract deleteCookie(name): void;
}
